// extracted by mini-css-extract-plugin
export default {"submitBtnContainer":"KzHD0LmLh3HZy9xo510h","linkContainer":"JDcMyIMpwgUDU0sNYk7r","accountManagementLink":"f3ezvPSEhbZWngqzt7wr"};